module.exports = __webpack_public_path__ + "img/IE.d55f6d58.svg";